import React from "react";
import { Container, Typography, Box } from "@mui/material";

const TempComponent = ({ title = "Componente Temporal" }) => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" color="primary" sx={{ mb: 3 }}>
                {title}
            </Typography>
            <Box>
                <Typography variant="body1" color="text.secondary">
                    Este componente está en desarrollo
                </Typography>
            </Box>
        </Container>
    );
};

export default TempComponent; 